import React from 'react';
import Anime from 'react-anime';
import CustomScroll from 'react-custom-scroll';
import BackToHomeBtn from './BackToHomeBtn';
import netflix from '../assets/netflix.JPG';
import GlassEmoji from '../assets/GlassEmoji';
import { BtnIcon } from './BackToHomeBtn';
import { projectsData } from '../data/data';
import '../styles/ProjectsPage.css';
import '../styles/customScroll.css';

const ProjectsList = props => {
   let paths=[]
    props.projects.forEach((project,index)=>{
      paths.push(require(`../assets/${project.thumb}`))
    }) 
   console.log(paths)
  return(
    props.projects.map((project, index) => 
      <div className="project-item" key={index}>
        
        <div className="project-heading">
          <h2>{project.name}</h2>
          <p> <strong>Tech Stack : </strong>{project.tech}</p>
        </div>
        <div className="thumb">
          <img src={paths[index]} alt="Project Preview"/>
        </div>
        <div className="project-links">
          {project.links.live && <a className="link" target="_blank" href={project.links.live}>Live Demo</a>}
          {project.links.repo && <a className="link" target="_blank" href={project.links.repo}>Repository</a>}
        </div>
        <div className="project-details">
          <p>{project.details}</p>
        </div>
      </div>
    )
  )
}

const ProjectsPage = props => {
  return(
    <Anime easing="easeOutCubic" opacity={[0, 1]} translateY={-30} duration={400} delay={300}>
      <div className="projects-page">
          <BackToHomeBtn handleClick={props.returnBtn}/>
          <Anime easing="easeOutCubic" left={[-350, -120]} duration={500} delay={800}>
            <p className="page-tag">Projects</p>
          </Anime>
          <CustomScroll heightRelativeToParent="calc(100% - 20px)">
            <div className="page-content">
              <h1>Lets talk work! </h1>
              <p className="page-intro">I like to try out new tools and technologies to create apps/sites that somehow make people's life easier. Below are some of the projects that I have worked on. </p>
              <div className="projects-container">
                <ProjectsList projects={projectsData}/>
              </div>
             <div align="center"> <a href="https://github.com/HimanshuBarak"><button  className="btn">More Projects</button></a> </div>
            </div>
          </CustomScroll>
      </div>
    </Anime>
  )
}

export default ProjectsPage;


// WEBPACK FOOTER //
// ./src/components/ProjectsPage.js